import { Alert, Box, Card, Divider, IconButton, Link } from "@mui/material";
import { BackForeColor } from "../../../components/common/BackForeColor";
import TotalValueItem from "../../event/components/TotalValueItem";
import PaymentIcon from "../../event/components/PaymentIcon";
import BillIcon from "../../event/components/BillIcon";
import localize from "../../../common/localize";
import { Delete, Edit } from "@mui/icons-material";

export default function DailyRoutEventItem({
  item,
  onEditObservation,
  onDelete,
}) {
  return (
    <Card variant="outlined" className="flex flex-col w-full gap-2 p-2">
      <Box className="flex justify-between items-center">
        <Box className="flex gap-2 items-center">
          {onDelete && (
            <Box>
              <IconButton onClick={onDelete}>
                <Delete sx={{ color: "red", width: "16px", height: "16px" }} />
              </IconButton>
            </Box>
          )}
          <Box className="two_columns_grid">
            <label className="text-xs">
              <b>{localize.code}:</b>
            </label>
            <Link
              className="text-xs"
              color="primary"
              underline="always"
              href="#"
              onClick={() => {
                window.open(`/events/detail/${item?.EventInfo?.Id}`, "_blank");
              }}
            >{`${item?.EventInfo?.Code}`}</Link>
          </Box>
        </Box>

        {item?.EventInfo?.ProceedingInfo && (
          <label className="text-xs">
            {item?.EventInfo?.ProceedingInfo?.Name}
          </label>
        )}
      </Box>

      <Divider />

      <Box className="w-full flex">
        <Box className="two_columns_grid">
          <Box className="flex items-center" sx={{ whiteSpace: '"nowrap' }}>
            <label className="text-xs">
              <b>{localize.event_type}:</b>
            </label>
          </Box>
          <BackForeColor
            styleName="text-xs"
            backColor={item?.EventInfo?.EventType.BackgroundColor}
            foreColor={item?.EventInfo?.EventType.ForegroundColor}
            text={item?.EventInfo?.EventType.Name}
          />
          <Box className="flex items-center" sx={{ whiteSpace: '"nowrap' }}>
            <label className="text-xs">
              <b>{localize.execution_status}:</b>
            </label>
          </Box>

          <BackForeColor
            backColor={
              item?.EventInfo?.OperationalStatus === 0
                ? "white"
                : item?.EventInfo?.CurrentStatus?.BackgroundColor
            }
            foreColor={
              item?.EventInfo?.OperationalStatus === 0
                ? "red"
                : item?.EventInfo?.CurrentStatus?.ForegroundColor
            }
            text={
              item?.EventInfo?.OperationalStatus === 0
                ? localize.cancelled
                : item?.EventInfo?.CurrentStatus?.Name
            }
            styleName={
              item?.EventInfo?.OperationalStatus === 0
                ? "cancelled_operational_status text-xs mt-1"
                : "text-xs mt-1"
            }
          />
        </Box>
      </Box>

      <Divider />

      <Box className="flex w-full justify-between">
        <Box className="two_columns_grid">
          <label className="text-xs">
            <b>{localize.client}:</b>
          </label>
          <label className="text-xs">
            {item?.EventInfo?.ReporterName ?? item?.EventInfo?.Client?.Name}
          </label>
          <label className="text-xs">
            <b>{localize.address}:</b>
          </label>
          <label className="text-xs">
            {item?.EventInfo?.Address
              ? `${item?.EventInfo?.Address} ${
                  item?.EventInfo?.AddressComplement ?? ""
                }`
              : item?.EventInfo?.Client.Address}
          </label>
          <label className="text-xs">
            <b>{localize.phone_number}:</b>
          </label>
          <label className="text-xs">
            {item?.EventInfo?.ReporterPhoneNumber ??
              item?.EventInfo?.Client?.PhoneNumber}
          </label>
          <label className="text-xs">
            <b>{localize.total_value}:</b>
          </label>
          <TotalValueItem
            notCentered
            customStyle="text-xs"
            item={item?.EventInfo}
          />

          <label className="text-xs">
            <b>{localize.assigned_to}:</b>
          </label>
          {item?.EventInfo?.PersonalAssigned ? (
            <label className="text-xs">{`${item?.EventInfo?.PersonalAssigned.SurName} ${item?.EventInfo?.PersonalAssigned.LastName}`}</label>
          ) : (
            <label className="text-xs">{localize.no_data}</label>
          )}
          <label className="text-xs">
            <b>{localize.creation_date}:</b>
          </label>
          <label className="text-xs">
            {new Date(item?.EventInfo?.CreationDate).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </label>
        </Box>

        <Box className="flex flex-col gap-2">
          <Box className="flex gap-2 items-center justify-between">
            <label className="text-xs">
              <b>{localize.payed}: </b>
            </label>
            <PaymentIcon item={item?.EventInfo} />
          </Box>
          <Box className="flex gap-2 items-center">
            <label className="text-xs">
              <b>{localize.billed}:</b>
            </label>
            <BillIcon item={item?.EventInfo} />
          </Box>
        </Box>
      </Box>

      <Box className="w-full flex gap-2 items-center">
        {onEditObservation && (
          <Box>
            <IconButton onClick={onEditObservation}>
              <Edit sx={{ width: "16px", height: "16px", color: "#10366E" }} />
            </IconButton>
          </Box>
        )}

        <Alert severity="info" className="w-full">
          <label className="text-xs">
            <b>{localize.observations}: </b>
            {item?.Observation && item?.Observation?.length > 0
              ? item?.Observation
              : localize.no_data}
          </label>
        </Alert>
      </Box>
    </Card>
  );
}
